unit UnclaimedValidationAutoFixForm;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.Controls, WEBLib.StdCtrls, WebForm.Core,
  Vcl.StdCtrls;

type
  TUnclaimedValidationAutoFixForm = class(TCoreWebForm)
    FixTooOldCheck: TCheckBox;
    FixNoDeclarationCheck: TCheckBox;
    FixZeroAmountCheck: TCheckBox;
    FixPostcodesCheck: TCheckBox;
    FixDonorNamesCheck: TCheckBox;
    RunButton: TButton;
    CancelButton: TButton;
    procedure WebFormCreate(Sender: TObject);
    procedure RunButtonClick(Sender: TObject);
  private
    function AnyOptionSelected: Boolean;
  public
    function FixTooOld: Boolean;
    function FixNoDeclaration: Boolean;
    function FixZeroAmount: Boolean;
    function FixPostcodes: Boolean;
    function FixDonorNames: Boolean;
  protected procedure LoadDFMValues; override; end;

implementation

{$R *.dfm}

uses
  WEBLib.WebCtrls, MainDataModule;

procedure TUnclaimedValidationAutoFixForm.WebFormCreate(Sender: TObject);
begin
  inherited;
  FixTooOldCheck.Checked := True;
  FixNoDeclarationCheck.Checked := True;
  FixZeroAmountCheck.Checked := True;
  FixPostcodesCheck.Checked := True;
  FixDonorNamesCheck.Checked := True;
end;

function TUnclaimedValidationAutoFixForm.FixTooOld: Boolean;
begin
  Result := FixTooOldCheck.Checked;
end;

function TUnclaimedValidationAutoFixForm.FixNoDeclaration: Boolean;
begin
  Result := FixNoDeclarationCheck.Checked;
end;

function TUnclaimedValidationAutoFixForm.FixZeroAmount: Boolean;
begin
  Result := FixZeroAmountCheck.Checked;
end;

function TUnclaimedValidationAutoFixForm.FixPostcodes: Boolean;
begin
  Result := FixPostcodesCheck.Checked;
end;

function TUnclaimedValidationAutoFixForm.FixDonorNames: Boolean;
begin
  Result := FixDonorNamesCheck.Checked;
end;

function TUnclaimedValidationAutoFixForm.AnyOptionSelected: Boolean;
begin
  Result := FixTooOld or FixNoDeclaration or FixZeroAmount or FixPostcodes or FixDonorNames;
end;

procedure TUnclaimedValidationAutoFixForm.RunButtonClick(Sender: TObject);
begin
  if not AnyOptionSelected then
  begin
    DisplayMessage('Select at least one fix to run.', mtWarning);
    Exit;
  end;
  ModalResult := mrOk;
end;

procedure TUnclaimedValidationAutoFixForm.LoadDFMValues;
begin
  inherited LoadDFMValues;

  FixTooOldCheck := TCheckBox.Create('FixTooOldCheck');
  FixNoDeclarationCheck := TCheckBox.Create('FixNoDeclarationCheck');
  FixZeroAmountCheck := TCheckBox.Create('FixZeroAmountCheck');
  FixPostcodesCheck := TCheckBox.Create('FixPostcodesCheck');
  FixDonorNamesCheck := TCheckBox.Create('FixDonorNamesCheck');
  CancelButton := TButton.Create('AutoFixCancelButton');
  RunButton := TButton.Create('AutoFixRunButton');

  FixTooOldCheck.BeforeLoadDFMValues;
  FixNoDeclarationCheck.BeforeLoadDFMValues;
  FixZeroAmountCheck.BeforeLoadDFMValues;
  FixPostcodesCheck.BeforeLoadDFMValues;
  FixDonorNamesCheck.BeforeLoadDFMValues;
  CancelButton.BeforeLoadDFMValues;
  RunButton.BeforeLoadDFMValues;
  try
    Width := 520;
    Height := 340;
    Caption := 'Apply Fixes';
    ElementClassName := 'PopUpForm';
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    FixTooOldCheck.SetParentComponent(Self);
    FixTooOldCheck.Name := 'FixTooOldCheck';
    FixTooOldCheck.Left := 16;
    FixTooOldCheck.Top := 56;
    FixTooOldCheck.Width := 488;
    FixTooOldCheck.Height := 22;
    FixTooOldCheck.Caption := 'Set donations before the earliest claimable date to Non-Gift Aidable';
    FixTooOldCheck.Checked := True;
    FixTooOldCheck.ElementFont := efCSS;
    FixTooOldCheck.ElementPosition := epIgnore;
    FixTooOldCheck.HeightStyle := ssAuto;
    FixTooOldCheck.HeightPercent := 100.000000000000000000;
    FixTooOldCheck.State := cbChecked;
    FixTooOldCheck.WidthStyle := ssAuto;
    FixTooOldCheck.WidthPercent := 100.000000000000000000;
    FixNoDeclarationCheck.SetParentComponent(Self);
    FixNoDeclarationCheck.Name := 'FixNoDeclarationCheck';
    FixNoDeclarationCheck.Left := 16;
    FixNoDeclarationCheck.Top := 84;
    FixNoDeclarationCheck.Width := 488;
    FixNoDeclarationCheck.Height := 22;
    FixNoDeclarationCheck.Caption := 'Set donations with no valid Gift Aid declaration to Non-Gift Aidable';
    FixNoDeclarationCheck.Checked := True;
    FixNoDeclarationCheck.ElementFont := efCSS;
    FixNoDeclarationCheck.ElementPosition := epIgnore;
    FixNoDeclarationCheck.HeightStyle := ssAuto;
    FixNoDeclarationCheck.HeightPercent := 100.000000000000000000;
    FixNoDeclarationCheck.State := cbChecked;
    FixNoDeclarationCheck.WidthStyle := ssAuto;
    FixNoDeclarationCheck.WidthPercent := 100.000000000000000000;
    FixZeroAmountCheck.SetParentComponent(Self);
    FixZeroAmountCheck.Name := 'FixZeroAmountCheck';
    FixZeroAmountCheck.Left := 16;
    FixZeroAmountCheck.Top := 112;
    FixZeroAmountCheck.Width := 488;
    FixZeroAmountCheck.Height := 22;
    FixZeroAmountCheck.Caption := 'Set donations with amount 0.00 to Non-Gift Aidable';
    FixZeroAmountCheck.Checked := True;
    FixZeroAmountCheck.ElementFont := efCSS;
    FixZeroAmountCheck.ElementPosition := epIgnore;
    FixZeroAmountCheck.HeightStyle := ssAuto;
    FixZeroAmountCheck.HeightPercent := 100.000000000000000000;
    FixZeroAmountCheck.State := cbChecked;
    FixZeroAmountCheck.WidthStyle := ssAuto;
    FixZeroAmountCheck.WidthPercent := 100.000000000000000000;
    FixPostcodesCheck.SetParentComponent(Self);
    FixPostcodesCheck.Name := 'FixPostcodesCheck';
    FixPostcodesCheck.Left := 16;
    FixPostcodesCheck.Top := 140;
    FixPostcodesCheck.Width := 488;
    FixPostcodesCheck.Height := 22;
    FixPostcodesCheck.Caption := 'Trim postcodes and remove double spaces (donor and donation)';
    FixPostcodesCheck.Checked := True;
    FixPostcodesCheck.ElementFont := efCSS;
    FixPostcodesCheck.ElementPosition := epIgnore;
    FixPostcodesCheck.HeightStyle := ssAuto;
    FixPostcodesCheck.HeightPercent := 100.000000000000000000;
    FixPostcodesCheck.State := cbChecked;
    FixPostcodesCheck.WidthStyle := ssAuto;
    FixPostcodesCheck.WidthPercent := 100.000000000000000000;
    FixDonorNamesCheck.SetParentComponent(Self);
    FixDonorNamesCheck.Name := 'FixDonorNamesCheck';
    FixDonorNamesCheck.Left := 16;
    FixDonorNamesCheck.Top := 168;
    FixDonorNamesCheck.Width := 488;
    FixDonorNamesCheck.Height := 22;
    FixDonorNamesCheck.Caption := 'Remove trailing spaces and periods from title, first name and last name';
    FixDonorNamesCheck.Checked := True;
    FixDonorNamesCheck.ElementFont := efCSS;
    FixDonorNamesCheck.ElementPosition := epIgnore;
    FixDonorNamesCheck.HeightStyle := ssAuto;
    FixDonorNamesCheck.HeightPercent := 100.000000000000000000;
    FixDonorNamesCheck.State := cbChecked;
    FixDonorNamesCheck.WidthStyle := ssAuto;
    FixDonorNamesCheck.WidthPercent := 100.000000000000000000;
    CancelButton.SetParentComponent(Self);
    CancelButton.Name := 'CancelButton';
    CancelButton.Left := 312;
    CancelButton.Top := 296;
    CancelButton.Width := 88;
    CancelButton.Height := 28;
    CancelButton.Caption := 'Cancel';
    CancelButton.ChildOrder := 10;
    CancelButton.ElementClassName := 'btn btn-light me-2';
    CancelButton.ElementFont := efCSS;
    CancelButton.ElementPosition := epIgnore;
    CancelButton.HeightStyle := ssAuto;
    CancelButton.HeightPercent := 100.000000000000000000;
    CancelButton.ModalResult := 2;
    CancelButton.WidthStyle := ssAuto;
    CancelButton.WidthPercent := 100.000000000000000000;
    RunButton.SetParentComponent(Self);
    RunButton.Name := 'RunButton';
    RunButton.Left := 408;
    RunButton.Top := 296;
    RunButton.Width := 96;
    RunButton.Height := 28;
    RunButton.Caption := 'Run fixes';
    RunButton.ChildOrder := 11;
    RunButton.ElementClassName := 'btn btn-primary';
    RunButton.ElementFont := efCSS;
    RunButton.ElementPosition := epIgnore;
    RunButton.HeightStyle := ssAuto;
    RunButton.HeightPercent := 100.000000000000000000;
    RunButton.WidthStyle := ssAuto;
    RunButton.WidthPercent := 100.000000000000000000;
    SetEvent(RunButton, Self, 'OnClick', 'RunButtonClick');
  finally
    FixTooOldCheck.AfterLoadDFMValues;
    FixNoDeclarationCheck.AfterLoadDFMValues;
    FixZeroAmountCheck.AfterLoadDFMValues;
    FixPostcodesCheck.AfterLoadDFMValues;
    FixDonorNamesCheck.AfterLoadDFMValues;
    CancelButton.AfterLoadDFMValues;
    RunButton.AfterLoadDFMValues;
  end;
end;

end.
